import React, { Fragment } from 'react';
import { Intro, MultipleChoice } from 'abbot-core';
import img from '../../assets/images/U1-T2-1-5.svg';

const data = {
  inputType: 'radio',
  question: 'The U.S. MyPlate nutrition guidelines suggest that your daily food intake should include foods from _____major food groups.',
  options: [
    {
      label: '3'
    },
    {
      label: '4'
    },
    {
      label: '5'
    },
    {
      label: '6'
    },
    {
      label: '7'
    }
  ]
};

const correctInput = {
  [data.question]: data.options[2].label
};

const feedback = {
  success: {
    title: 'You got it!',
    body: 'MyPlate nutrition guidelines suggest that your daily food intake should include foods from 5 major food groups. You’ll learn more in the module.'
  },
  error: {
    title: 'Not exactly.',
    body: 'MyPlate nutrition guidelines suggest that your daily food intake should include foods from 5 major food groups. You’ll learn more in the module.'
  }
};


export default {
  title: 'Question 3',
  path: '/prepare/question-3',
  content: (
    <Fragment>
      <Intro
        title="Show What You Know"
        direction="Select the best answer to each question."
        img={img}
      />

      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
      />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/prepare/Question3.js